const getOptsByIndex = (list) => list.map((label, index) => ({ label, value: index }));
export const resourseOpts = getOptsByIndex(['默认排序', '最新发布', '当前最热', '综合排序']);
export const pluginOpts = getOptsByIndex(['默认排序', '最多安装', '最多点赞', '最多浏览', '综合排序']);
